import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Api from "../Auth/Api";
import Clappr from 'clappr';


function Aula() {

    const navigate = useNavigate();
    const token = JSON.parse(localStorage.getItem("user_token"));
    const { id } = useParams();
    const tempoAula = process.env.REACT_APP_TEMPO_AULA;
    const isMobileAndHorizontal = window.matchMedia('(orientation: landscape)').matches;
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const [isFullscreen, setIsFullscreen] = useState(false);
    const clapprPlayerRef = useRef(null);
    const contentRef = useRef(null);
    const progressIntervalRef = useRef(null);

    const [dataInfoAula, setDataInfoAula] = useState([]);
    const arquivoPrincipal = dataInfoAula[0] && JSON.parse(dataInfoAula[0].arquivos)[0]
    const validExtensions = useMemo(() => ["mp4", "avi", "mkv", "mov"], []);

    // Função para obter o MIME type baseado na extensão
    const getMimeType = (extension) => {
        const mimeTypes = {
            'mp4': 'video/mp4',
            'avi': 'video/x-msvideo',
            'mkv': 'video/x-matroska',
            'mov': 'video/quicktime',
            'webm': 'video/webm'
        };
        return mimeTypes[extension?.toLowerCase()] || 'video/mp4';
    };

    let urlPrincipal = '';
    const html_externo = dataInfoAula[0] && dataInfoAula[0].html_externo;
    if (html_externo) {
        urlPrincipal = html_externo;
    } else {
        urlPrincipal = `${process.env.REACT_APP_FILES_URL}/${arquivoPrincipal}&token=${token}`
    }

    let listaArquivos = [];

    if (dataInfoAula[0] && dataInfoAula[0].arquivos) {
        const parsedData = JSON.parse(dataInfoAula[0].arquivos);
        if (Array.isArray(parsedData)) {
            listaArquivos = parsedData;
        }
    }

    // Agora, você pode prosseguir com as operações no array, como filtragem:
    listaArquivos = listaArquivos.filter(item => item);

    // Remover o item com índice 0
    listaArquivos.splice(0, 1);

    // Funções para gerenciar progresso no localStorage
    const getStorageKey = useCallback(() => `aula_progress_${id}`, [id]);

    const loadProgress = useCallback(() => {
        try {
            const saved = localStorage.getItem(getStorageKey());
            if (saved) {
                const { time, completed } = JSON.parse(saved);
                if (!completed) {
                    return time || 0;
                }
            }
        } catch (error) {
            console.error('❌ Erro ao carregar progresso:', error);
        }
        return 0;
    }, [getStorageKey]);

    const saveProgress = useCallback((time, completed = false) => {
        try {
            const progressData = {
                time,
                completed,
                lastUpdate: new Date().toISOString()
            };
            localStorage.setItem(getStorageKey(), JSON.stringify(progressData));
        } catch (error) {
            console.error('❌ Erro ao salvar progresso:', error);
        }
    }, [getStorageKey]);

    const clearProgress = useCallback(() => {
        try {
            localStorage.removeItem(getStorageKey());
        } catch (error) {
            console.error('❌ Erro ao limpar progresso:', error);
        }
    }, [getStorageKey]);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/info-aula/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataInfoAula(response.data);
                // Carregar progresso salvo
                loadProgress();
            } catch (error) {
                console.error(error.response.data.message)
                navigate("/");
            }
        }

        fetchData();
    }, [token, id, navigate, loadProgress]);


    // Inicializar Clappr player
    useEffect(() => {
        if (!dataInfoAula[0] || !arquivoPrincipal) return;

        // Destruir player anterior se existir
        if (clapprPlayerRef.current) {
            clapprPlayerRef.current.destroy();
            clapprPlayerRef.current = null;
        }

        // Status de visualização
        let marcadoComoAssistido = false;
        let lastSavedTime = 0;
        let accumulatedTime = 0;

        // Função para marcar como assistido com retry
        const marcarComoAssistido = async (tentativas = 3) => {
            if (marcadoComoAssistido) {
                return;
            }

            try {
                await Api.post(`api/progresso-aula/${id}`, { data: 'assistida' }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                marcadoComoAssistido = true;
                saveProgress(0, true);
                clearProgress();
            } catch (error) {
                console.error('Erro ao marcar aula como assistida:', error);
                if (tentativas > 0) {
                    setTimeout(() => marcarComoAssistido(tentativas - 1), 5000);
                }
            }
        };

        // Para conteúdo de vídeo - usar Clappr
        if (validExtensions.includes(dataInfoAula[0].extensao)) {
            const mimeType = getMimeType(dataInfoAula[0].extensao);

            const player = new Clappr.Player({
                parentId: '#clappr-player-container',
                source: urlPrincipal,
                mimeType: mimeType,
                width: '100%',
                height: '100%',
                autoPlay: false,
                mute: false,
                preload: 'metadata',
                events: {
                    onReady: () => {
                        console.log('Clappr player ready');
                    },
                    onLoadedMetadata: () => {
                        const duration = player.getDuration();
                        console.log('Metadados carregados - Duração do vídeo:', duration);
                    },
                    onPlay: () => {
                        console.log('Clappr player started playing');
                    },
                    onEnded: () => {
                        if (!marcadoComoAssistido) {
                            marcarComoAssistido();
                        }
                    },
                    onTimeUpdate: () => {
                        
                        // Incrementar tempo acumulado (baseado em tempoAula, não duração do vídeo)
                        accumulatedTime += 1; // Incrementa 1 segundo a cada chamada
                        
                        
                        // Salvar progresso a cada 5 segundos
                        if (accumulatedTime - lastSavedTime >= 5) {
                            saveProgress(accumulatedTime, false);
                            lastSavedTime = accumulatedTime;
                        }
                        
                        // Marcar como assistido quando atingir o tempoAula
                        const requiredTime = parseInt(tempoAula) || 60; // tempoAula em segundos
                        if (accumulatedTime >= requiredTime && !marcadoComoAssistido) {
                            marcarComoAssistido();
                        }
                    }
                }
            });

            clapprPlayerRef.current = player;
        } else {
            // Para conteúdo não-vídeo (PDF, iframe, etc)
            if (dataInfoAula[0].extensao && dataInfoAula[0].extensao.toLowerCase() === 'pdf') {
                marcarComoAssistido();
                return;
            }

            // Sistema híbrido para outros conteúdos
            let accumulatedTime = loadProgress();
            let isVisible = false;
            let isPageVisible = document.visibilityState === 'visible';
            let progressInterval = null;

            const requiredTime = tempoAula;

            const updateProgress = () => {
                if (isVisible && isPageVisible && !marcadoComoAssistido) {
                    accumulatedTime += 1;

                    if (accumulatedTime % 5 === 0) {
                        saveProgress(accumulatedTime, false);
                    }

                    if (accumulatedTime >= requiredTime) {
                        marcarComoAssistido();
                    }
                }
            };

            const observerCallback = (entries) => {
                entries.forEach(entry => {
                    isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
                });
            };

            const observer = new IntersectionObserver(observerCallback, {
                threshold: [0, 0.5, 1.0]
            });

            const waitForElement = setInterval(() => {
                const contentElement = document.querySelector('.iframe-container, .responsive-iframe-wrapper');
                if (contentElement) {
                    clearInterval(waitForElement);

                    observer.observe(contentElement);
                    contentRef.current = contentElement;

                    progressInterval = setInterval(updateProgress, 1000);
                    progressIntervalRef.current = progressInterval;
                }
            }, 100);

            const handleVisibilityChange = () => {
                isPageVisible = document.visibilityState === 'visible';
            };

            document.addEventListener('visibilitychange', handleVisibilityChange);

            return () => {
                clearInterval(waitForElement);
                if (progressInterval) {
                    clearInterval(progressInterval);
                }
                if (observer) {
                    observer.disconnect();
                }
                document.removeEventListener('visibilitychange', handleVisibilityChange);

                if (!marcadoComoAssistido && accumulatedTime > 0) {
                    saveProgress(accumulatedTime, false);
                }
            };
        }

        return () => {
            if (clapprPlayerRef.current) {
                clapprPlayerRef.current.destroy();
                clapprPlayerRef.current = null;
            }
        };
    }, [dataInfoAula, id, token, validExtensions, tempoAula, loadProgress, saveProgress, clearProgress, arquivoPrincipal, urlPrincipal]);

    // Detectar mudanças no fullscreen
    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, []);

    const toggleFullscreen = () => {
        if (isFullscreen) {
            exitFullscreen();
        } else {
            enterFullscreen();
        }
    };

    const enterFullscreen = () => {
        const container = document.querySelector('.video-container');
        if (container && container.requestFullscreen) {
            container.requestFullscreen().then(() => {
                setIsFullscreen(true);
            }).catch((err) => {
                console.error('Erro ao entrar em fullscreen:', err);
            });
        }
    };

    const exitFullscreen = () => {
        if (document.exitFullscreen) {
            document.exitFullscreen().then(() => {
                setIsFullscreen(false);
            }).catch((err) => {
                console.error('Erro ao sair do fullscreen:', err);
            });
        }
    };

    return (
        <>
            {dataInfoAula[0] &&
                <div className="fade-in w-100 mb-5">

                    {!isFullscreen && (
                        <Link onClick={() => navigate(-1)} className="btn text-primary link border-0 fs-6 my-3 my-md-0">
                            <i className="bi bi-chevron-left"></i> Voltar
                        </Link>
                    )}

                    {arquivoPrincipal !== undefined &&
                        <div className={`body ${isFullscreen ? 'fullscreen-body' : ''}`}>
                            <section className="w-100 position-relative">
                                {validExtensions.includes(dataInfoAula[0].extensao) ? (
                                    <div
                                        className="video-container rounded-3 overflow-hidden w-100 bg-dark position-relative"
                                        style={{
                                            position: isFullscreen ? 'fixed' : 'relative',
                                            top: isFullscreen ? 0 : 'auto',
                                            left: isFullscreen ? 0 : 'auto',
                                            width: isFullscreen ? '100%' : '100%',
                                            height: isFullscreen ? '100%' : 'auto',
                                            zIndex: isFullscreen ? 9999 : 'auto',
                                        }}
                                    >
                                        <div
                                            id="clappr-player-container"
                                            className="aula-video-player-container"
                                            style={{
                                                flex: '1 1 0%',
                                                width: '100%',
                                                height: isMobile ? '60vh' : '70vh',
                                                minHeight: isMobile ? '250px' : '400px',
                                                maxHeight: isMobile ? '60vh' : '70vh',
                                                display: 'block',
                                                visibility: 'visible',
                                                opacity: 1,
                                                position: 'relative',
                                                backgroundColor: '#000'
                                            }}
                                        ></div>
                                        <button
                                            onClick={toggleFullscreen}
                                            className="btn btn-sm btn-primary"
                                            style={{
                                                position: 'absolute',
                                                top: '10px',
                                                right: '10px',
                                                zIndex: 10000,
                                                opacity: 0.7,
                                            }}
                                        >
                                            {isFullscreen ? (
                                                <i className="bi bi-fullscreen-exit"></i>
                                            ) : (
                                                <i className="bi bi-fullscreen"></i>
                                            )}
                                        </button>
                                    </div>
                                ) : (
                                    <div
                                        className="iframe-container rounded-3 overflow-hidden w-100 bg-dark position-relative"
                                        style={{
                                            position: isFullscreen ? 'fixed' : 'relative',
                                            top: isFullscreen ? 0 : 'auto',
                                            left: isFullscreen ? 0 : 'auto',
                                            width: isFullscreen ? '100%' : '100%',
                                            height: isFullscreen ? '100%' : 'auto',
                                            zIndex: isFullscreen ? 9999 : 'auto',
                                        }}
                                    >
                                        <div className="responsive-iframe-wrapper"
                                            style={{
                                                position: 'relative',
                                                paddingTop: isFullscreen ? '80vh' : (isMobile && isMobileAndHorizontal ? '80vh' : isMobile ? '120%' : '40%'),
                                                width: '100%',
                                                backgroundColor: '#000',
                                                maxHeight: isMobile && isMobileAndHorizontal ? '100vh' : 'none'
                                            }}>
                                            <iframe
                                                className="responsive-iframe"
                                                src={urlPrincipal}
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    border: 'none',
                                                    objectFit: 'contain'
                                                }}
                                                title={dataInfoAula[0].titulo}
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                        <button
                                            onClick={toggleFullscreen}
                                            className="btn btn-sm btn-primary"
                                            style={{
                                                position: 'absolute',
                                                top: '10px',
                                                left: '10px',
                                                zIndex: 10000,
                                                opacity: 0.7,
                                            }}
                                        >
                                            {isFullscreen ? (
                                                <i className="bi bi-fullscreen-exit"></i>
                                            ) : (
                                                <i className="bi bi-fullscreen"></i>
                                            )}
                                        </button>
                                    </div>
                                )}
                            </section>
                        </div>
                    }

                    {!isFullscreen && (
                        <div className="card mt-3 mb-5 py-3 px-4 bg-primary text-white back-image border-none">
                            <div className="d-flex align-items-center row g-0">
                                {
                                    dataInfoAula[0].arquivos &&
                                    listaArquivos.map((value, index) => {
                                        return (
                                            <div key={index} className="col-md-3 overflow-hidden bg-white text-center rounded m-2">
                                                <span className="d-flex bg-grey w-100 space-grey"></span>
                                                <Link target="_blank" to={`${process.env.REACT_APP_FILES_URL}/${value}&token=${token}`}>
                                                    <button type="button" className="btn fs-6 text-primary link py-3">
                                                        Baixar conteúdo <i className="bi bi-download ms-2"></i>
                                                    </button>
                                                </Link>
                                            </div>
                                        )
                                    })
                                }


                                <div className="col-md-3">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <span className="fs-4 fw-500">{dataInfoAula[0].titulo}</span>
                                        </div>
                                        <span className="fw-light text-break">
                                            {dataInfoAula[0].descricao}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div >
            }

        </>
    )
}

export default Aula;